import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ForumService } from '../forum.service';
import { UserService } from '../../../core/services/core.user.service';
import { GfTitleService } from '../../../core/services/core.title.service';
import { StateService } from '@uirouter/angular';
import { ForumEditModalComponent } from '../edit/forum.edit-modal.component';
import { ForumDeleteModalComponent } from '../forum-delete/forum.delete.modal';
import { isMarkdownBody } from '../../../core/services/message-body-format';

@Component({
  selector: 'forum-summary-view',
  template: require('./forum.summary.component.html'),
})
export class ForumSummaryViewComponent implements OnInit {
  @Input() siteConfig: any;
  @Input() project: any;
  @Input() projectMenu: any;
  @Input() user: any;

  domain: string;
  section: string;
  discussions: any = [];
  isSiteAdmin: boolean;
  forumPermissions: any;

  constructor(
    private forumService: ForumService,
    private window: Window,
    private modalService: NgbModal,
    private userService: UserService,
    private stateService: StateService,
    private titleService: GfTitleService,
  ) {
  }

  /**
   * Whether a message preview holds raw Markdown, which must not be piped
   * through the trusted-HTML pipe. Chat forums are not excluded from this
   * listing, so their messages can appear here.
   */
  isMarkdownMessage(message: any): boolean {
    return isMarkdownBody(message);
  }

  ngOnInit() {
    this.titleService.setTitle(this.project.name, 'Discussions');
    this.domain = this.siteConfig.hostName;
    this.section = 'forum';
    this.discussions = false;
    this.isSiteAdmin = this.userService.session.isSiteAdmin();
    this.forumPermissions = _.get(this, 'project.rel.permissions.forums', {});

    this.loadPage();
  }

  newForum() {
    return {
      id: 0,
      forumName: '',
      description: '',
      sendAllPostsTo: '',
      moderationLevel: 0,
      isPublic: "N"
    };
  }

  isAdmin = _.memoize(this.checkIsAdmin.bind(this));

  editForum(forum) {
    const modalRef = this.modalService.open(ForumEditModalComponent);
      modalRef.componentInstance.forum = forum;
      modalRef.componentInstance.project = this.project;
      modalRef.componentInstance.domain = this.domain;
      modalRef.componentInstance.onClose.subscribe(() => {
        modalRef.close();
      });
      modalRef.componentInstance.onUpdate.subscribe(() => {
        this.loadPage();
        modalRef.close();
      });
  }

  showDeleteForum(forum) {
    const modalRef = this.modalService.open(ForumDeleteModalComponent);
    modalRef.componentInstance.forum = forum;

    modalRef.componentInstance.onDelete.subscribe(($event) => {
      if ($event.success) {
        this.loadPage();
      }
      modalRef.close();
    });

    modalRef.componentInstance.onClose.subscribe(() => {
      modalRef.close();
    });
  }

  private checkIsAdmin(forumId) {
    if (this.isSiteAdmin || _.get(this, 'project.rel.admin', false)) return true;

    if (forumId) {
      return _.get(this.forumPermissions, forumId, 0) > 2;
    } else {
      return _.get(this, 'project.rel.permissions.forum', 0) > 2;
    }
  }

  private loadPage() {
    this.discussions = null;

    const params = {
      section: 'project',
      refId: this.project.id,
      page_num: this.stateService.params.page_num,
      page_size: this.stateService.params.page_size,
      rel: 'mostRecentMessage'
    };

    this.forumService.fetch(params)
    .then((response) => {
      this.discussions = _.get(response, 'items', []);
    }, (response) => {
      console.log(response);
      this.discussions = [];
    });
  }

  updatePaging(paging) {
    this.stateService.go('.', paging, { notify: true });
  }

  trackByDiscussionId(index: number, discussion: any): any {
    return discussion.id;
  }
}

export default ForumSummaryViewComponent;